import { Axios } from "./request";

const API_URL = "usersapi/v1/candidates/";

export const CANDIDATES_API = {
  AddCandidate: (candidateProfileNumber) => {
    return Axios.post(`${API_URL}AddCandidate?candidateProfileNumber=${candidateProfileNumber}`);
  },
  GetMyCandidates: (from, size) => {
    return Axios.get(`${API_URL}GetMyCandidates?from=${from}&size=${size}`);
  },
  UpdateCandidatesOrder: (body) => {
    return Axios.put(`${API_URL}UpdateCandidatesOrder`, body);
  },
  RemoveCandidate: (candidateProfileNumber) => {
    return Axios.delete(
      `${API_URL}RemoveCandidate?candidateProfileNumber=${candidateProfileNumber}`
    );
  },
  RemoveCandidateWithId: (id, number) => {
    return Axios.delete(`${API_URL}RemoveCandidateWithId?id=${id}`, {
      transformResponse: (data) => ({ ...JSON.parse(data), number }),
    });
  },
  UnBookmarkProfileCandidate: (candidateProfileNumber) => {
    return Axios.delete(
      `${API_URL}UnBookmarkProfileCandidate?candidateProfileNumber=${candidateProfileNumber}`
    );
  },
};
